import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const ProfilePic = styled.img`
  height: 3rem;
`

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`

export const StaffTabsContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${Tokens.ColorBorder};
  margin-bottom: 8px;
`

export const StaffTab = styled.button<{ $active: boolean }>`
  padding: 10px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active }) => ($active ? Tokens.ColorUIPrimary : Tokens.ColorTextSecondary)};
  border-bottom: 2px solid ${({ $active }) => ($active ? Tokens.ColorUIPrimary : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    color: ${Tokens.ColorUIPrimary};
  }
`

export const AdminAllCompaniesTag = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  font-style: italic;
  color: ${Tokens.ColorTextSecondary};
  background-color: ${Tokens.ColorUIPrimaryLight};
`
